import { Route, Routes } from "react-router-dom"

import { DocumentDesktopLayout } from "../../layouts/DocumentDesktopLyout"

export function DocumentDesktopRouter() {

    return (
        <Routes>
            <Route
                path="/*"
                element={
                    <DocumentDesktopLayout />
                }
            />
        </Routes>
    )
}